import { render, staticRenderFns } from "./AboutChildSupportChanges.vue?vue&type=template&id=20627a7f"
import script from "./AboutChildSupportChanges.vue?vue&type=script&lang=ts"
export * from "./AboutChildSupportChanges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports